var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramSolid = function SvgInstagramSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.966 0C3.13 0 0 3.13 0 6.966v10.075C0 20.87 3.13 24 6.966 24h10.075C20.87 24 24 20.87 24 17.034V6.966C24 3.13 20.87 0 17.034 0H6.966Zm0 1.846h10.068a5.103 5.103 0 0 1 5.12 5.12v10.068a5.101 5.101 0 0 1-5.113 5.12H6.966a5.101 5.101 0 0 1-5.12-5.113V6.966a5.103 5.103 0 0 1 5.12-5.12Zm11.496 2.77a.92.92 0 0 1 .923-.924.92.92 0 0 1 .923.923.92.92 0 0 1-.923.923.92.92 0 0 1-.924-.923ZM12 5.537c-3.555 0-6.462 2.907-6.462 6.462 0 3.555 2.907 6.462 6.462 6.462 3.555 0 6.462-2.907 6.462-6.462 0-3.555-2.907-6.462-6.462-6.462ZM16.615 12A4.601 4.601 0 0 0 12 7.385 4.601 4.601 0 0 0 7.385 12 4.601 4.601 0 0 0 12 16.615 4.601 4.601 0 0 0 16.615 12Z",
    clipRule: "evenodd"
  })));
};
export default SvgInstagramSolid;